import ValidationErrors from '@/components/validation-errors';
import { team_onboarding_path } from '@/rails/routes';
import type { PageProps } from '@/types';
import { Button } from '@astryxdesign/core/Button';
import { Card } from '@astryxdesign/core/Card';
import { Heading } from '@astryxdesign/core/Heading';
import { Layout, LayoutContent, LayoutHeader } from '@astryxdesign/core/Layout';
import { Text } from '@astryxdesign/core/Text';
import { TextInput } from '@astryxdesign/core/TextInput';
import { VStack } from '@astryxdesign/core/VStack';
import { useForm, usePage } from '@inertiajs/react';
import type { FormEvent } from 'react';

interface Props extends PageProps {
  errors: string[];
  formData: {
    name?: string;
  };
}

const NewTeamOnboarding = () => {
  const { errors, formData } = usePage<Props>().props;
  const form = useForm({
    name: formData.name ?? '',
  });

  const submit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    form.transform((data) => ({ team: data }));
    form.post(team_onboarding_path());
  };

  return (
    <VStack vAlign="center" hAlign="center" width="100%" height="100dvh" className="p-4">
      <Card width="100%" maxWidth={448}>
        <Layout
          defaultHasDividers
          header={
            <LayoutHeader hasDivider>
              <Heading level={2}>Create your team</Heading>
              <Text type="supporting">
                Every account needs a team before entering the workspace.
              </Text>
            </LayoutHeader>
          }
          content={
            <LayoutContent>
              <form onSubmit={submit}>
                <VStack gap={4}>
                  <ValidationErrors errors={errors} />

                  <TextInput
                    label="Team name"
                    htmlName="name"
                    hasAutoFocus
                    isRequired
                    value={form.data.name}
                    onChange={(value) => form.setData('name', value)}
                  />

                  <Button
                    label="Create team"
                    variant="primary"
                    type="submit"
                    isDisabled={form.processing}
                    isLoading={form.processing}
                  />
                </VStack>
              </form>
            </LayoutContent>
          }
        />
      </Card>
    </VStack>
  );
};

export default NewTeamOnboarding;
